module.exports = __webpack_public_path__ + "assets/img/vtuber-app4.2c38f0ca.png";